import React from 'react'

/**
 * A 12-point-ish trend line for a stat tile.
 *
 * Hand-rolled SVG rather than a charting component: at this size recharts'
 * measurement machinery costs more than the mark is worth, and a viewBox with
 * `preserveAspectRatio="none"` scales to whatever width the tile has.
 *
 * `tone` picks the stroke colour via a class, keeping colour in the stylesheet.
 */
const Sparkline = ({ values = [], tone = 'muted' }) => {
    if (values.length < 2) return null

    const peak = Math.max(...values)
    const width = 100
    const height = 28
    const step = width / (values.length - 1)

    // A flat all-zero series would divide by zero; park it on the baseline.
    const scale = (value) => (peak > 0 ? height - (value / peak) * height : height)

    const points = values.map((value, index) => `${(index * step).toFixed(2)},${scale(value).toFixed(2)}`)
    const areaPoints = [`0,${height}`, ...points, `${width},${height}`].join(' ')

    return (
        <svg
            className={`viz-spark viz-spark--${tone}`}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            aria-hidden="true"
            focusable="false"
        >
            <polygon className="viz-spark-area" points={areaPoints} />
            <polyline className="viz-spark-line" points={points.join(' ')} />
        </svg>
    )
}

export default Sparkline
